import { tz, type Timezone } from "@towni/common";

/**
 * Retrieves the current timezone name of the user's environment.
 * If the timezone cannot be determined, defaults to "Europe/Stockholm".
 *
 * @constant {Timezone} currentTimezoneName - The name of the current timezone.
 */
const currentTimezoneName = (Intl.DateTimeFormat()?.resolvedOptions()
    ?.timeZone || tz.EuropeStockholm) as Timezone;

export { currentTimezoneName };
